const dateFormat = new Intl.DateTimeFormat([], {
  timeStyle: "short",
  dateStyle: "medium",
})

export const formatDateCreated = (date: string) => {
  return dateFormat.format(new Date(date))
}
